class KlevuSortBy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.select.element.addEventListener(
      'change',
      this.handleSelectChange.bind(this),
    )
  }

  handleSelectChange () {
    const selectedValue = this.els.select.element.value

    const correspondingDiv = Array.from(this.els.option.elements).find(
      el => el.getAttribute('data-value') === selectedValue,
    )

    if (correspondingDiv) {
      correspondingDiv.click()
    }
  }
}

if (!customElements.get('klevu-sortby')) {
  customElements.define('klevu-sortby', KlevuSortBy)
}
